import i18n from 'core/InitialiseThirdParties/i18n';
import { Discount, Item, OrderInformation } from 'services/order/order.type';

export const isPosDiscount = (discounts: Discount[]): boolean =>
    discounts.reduce((isPos, actualDiscount) => {
        return isPos ? actualDiscount.value === 0 : false;
    }, true);

export const searchForDiscountInItems = (discount: Discount, items: Item[]): Item | false => {
    const item = items.find(({ name }) => name.match(new RegExp(`${discount.name} `)));
    return item ?? false;
};

export const convertItemToDiscount = (
    { totalPriceWithTaxIncluded }: Item,
    name: string,
): Discount => ({
    name,
    value: Math.abs(totalPriceWithTaxIncluded),
});

export const mapItemsToDiscount = (discounts: Discount[], items: Item[]): Discount[] => {
    return discounts
        .map((discount) => {
            const item = searchForDiscountInItems(discount, items);
            return item ? convertItemToDiscount(item, discount.name) : false;
        })
        .filter<Discount>((discount): discount is Discount => !!discount);
};

export const mapOmnicanalOrderToDiscount = (order?: OrderInformation): Discount[] => {
    if (!order?.discounts?.length) {
        return [];
    }

    if (!isPosDiscount(order.discounts)) {
        return order.discounts;
    }

    return mapItemsToDiscount(order.discounts, order.items);
};

export const formatOrderDate = (date: string | undefined): string => {
    if (!date) {
        return '';
    }

    const datePart = getDatePartFromDate(date);
    const timePart = getTimePartFromDate(date);

    return `${datePart} - ${timePart}`;
};

export const getDatePartFromDate = (date: string): string => {
    const dateObject = new Date(date);
    return dateObject.toLocaleDateString(i18n.language, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
};

export const getTimePartFromDate = (date: string): string => {
    const dateObject = new Date(date);
    return dateObject.toLocaleTimeString(i18n.language, {
        hour: '2-digit',
        minute: '2-digit',
    });
};
